(() => {
  
  var ProductGraduatedDiscount = class extends HTMLElement {
    constructor() {
      super();
      this._show_graduated_discount = false;
      this.discount_amounts = [];
    }
    
    get show() {
      return this._show_graduated_discount;
    }
    
    set show(value) {
      if (this._show_graduated_discount != value) {
        this.initialContainer.classList.toggle('hidden');
        this.discountedContainer.classList.toggle('hidden');
        this._show_graduated_discount = value;
      }
    }
    
    connectedCallback() {
      this.form_id = this.dataset.formId;
      this.initialContainer = this.querySelector('[data-price-initial]');
      this.discountedContainer = this.querySelector('[data-price-discounted]');
      this.quantityInput = document.querySelector(`input[form=${this.form_id}][name=quantity]`);
      let quantitySelector = document.querySelector('quantity-selector');
      this.querySelectorAll(`[data-price-discounted]`).forEach(element => this.discount_amounts.push(parseInt(element.getAttribute('data-quantity'))));
      this.discount_amounts.sort().reverse();
      quantitySelector.querySelector('input').addEventListener('change', (e) => this.handleQuantityChange(parseInt(e.target.value)));
      quantitySelector.querySelector('button:first-child').addEventListener('click', () => this.handleQuantityChange(this.quantityInput.quantity - 1));
      quantitySelector.querySelector('button:last-child').addEventListener('click', () => this.handleQuantityChange(this.quantityInput.quantity + 1));
    }
    
    handleQuantityChange(newQuantity) {
      let mached_quantity = 1;
      this.discount_amounts.forEach(amount => { if (newQuantity >= amount) mached_quantity = amount; });
      this.querySelectorAll(`[data-price-container]`).forEach((element) => element.classList.add('hidden'));
      this.querySelector(`[data-price-container][data-quantity="${mached_quantity}"]`).classList.remove('hidden');
    }
  }
  
  window.customElements.define(
    "graduated-discount",
    ProductGraduatedDiscount
  );
  
})();